import {
    SuspenseWrapper,
    ToastError,
} from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { Outlet } from 'react-router-dom';
import 'app/agriculture/routes/BackOffice/BackOfficeMain.scss';
import { BackOfficeTopBar } from 'app/agriculture/routes/BackOffice/BackOfficeTopBar';

export function BackOfficeMain() {
    return (
        <SuspenseWrapper loadingComponent={null} ErrorComponent={ToastError}>
            <div className="BackOfficeMain">
                <div className="BackOfficeMain__container">
                    <BackOfficeTopBar />
                    {/* TODO: Scroll bar should be inside the outlet, not out here */}
                    <div className="BackOfficeMain__content">
                        <div className="BackOfficeMain__inner_container">
                            <SuspenseWrapper>
                                <Outlet />
                            </SuspenseWrapper>
                        </div>
                    </div>
                </div>
            </div>
        </SuspenseWrapper>
    );
}
